import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCompassIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="icon-compass_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M723.243 341.205a32 32 0 0 0-40.448-40.49l-271.36 90.453a32 32 0 0 0-20.267 20.267l-90.453 271.36a32 32 0 0 0 40.533 40.448l271.36-90.454a32 32 0 0 0 20.181-20.224l90.454-271.36zM381.696 642.304l65.152-195.456 195.456-65.152-65.152 195.413-195.456 65.195zM512 53.333C258.688 53.333 53.333 258.688 53.333 512S258.688 970.667 512 970.667 970.667 765.312 970.667 512 765.312 53.333 512 53.333zM117.333 512a394.667 394.667 0 1 1 789.334 0 394.667 394.667 0 0 1-789.334 0z"
    />
  </svg>
);
export default SvgIconCompassIcon;
